import PaymentUtils from 'payment';
import { useCardBrand, images } from 'react-card-brand';

const CreditCardBrand = (props) => {
  const { getSvgProps } = useCardBrand();

  const brand = PaymentUtils.fns.cardType(props.number);

  if(brand){
    return (
      <svg {...getSvgProps({ type: brand, images })} />
    )
  }
  else return null;
}

export default CreditCardBrand;
